import createReactComponent from '../createReactComponent';
export default createReactComponent('sign-left', 'IconSignLeft', [
  ['path', { d: 'M16 21h-4', key: 'svg-0' }],
  ['path', { d: 'M14 21v-10', key: 'svg-1' }],
  ['path', { d: 'M14 6v-3', key: 'svg-2' }],
  ['path', { d: 'M18 6h-10l-2 2.5l2 2.5h10z', key: 'svg-3' }],
]);
